import emitter from "@webcore/core/events/eventemitter.ts";
import * as Sentry from "@sentry/react";


if (import.meta.env.DEV ) {
  // import("./utils/stats").then(({ initStats }) => initStats()).catch(() => {});
  import("./utils/eruda").then(({ initEruda }) => initEruda()).catch(() => {});
}
import("./main.app.ui").then(({ initUI }) => {
  initUI();
});

emitter.on("ui-ready", () => {
  import("./main.app").then(({ initApp }) => {
    initApp();
  });
});

//----------------------------------------------------------------

emitter.on("initialized", () => {
  emitter.emit("load");
});

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://7d02efcffe09ec8c59bf162b29b09093@o1388406.ingest.us.sentry.io/4511567973711872",
    maxBreadcrumbs: 20,
    integrations: [
      Sentry.breadcrumbsIntegration({
        console: false,
        dom: false,
      }),
    ],
    beforeBreadcrumb(breadcrumb) {
      try {
        if (JSON.stringify(breadcrumb).length > 5000) return null;
      } catch {
        return null;
      }
      return breadcrumb;
    },
  });
}